// import logo from './logo.svg';
import './index.css'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './page';
import AboutComp from './about/page';
import Gallery from './public-campaign/page';
import ContactForm from './contact/page';
import GalleryImages from './gallery/page';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<HomePage/>}/>
        <Route path='/about' element={<AboutComp/>}/>
        <Route path='/gallery' element={<GalleryImages/>}/>
        <Route path='/public-campaign' element={<Gallery/>}/>
        <Route path='/contact' element={<ContactForm/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
